// extracted by mini-css-extract-plugin
export var activeFilterButton = "_px-c";
export var backButton = "_px-4";
export var backIcon = "_px-5";
export var chevronShortcut = "_px-6";
export var container = "_px-1";
export var editor = "_px-8";
export var editorWrapper = "_px-7";
export var prefix = "_px-2";
export var searchIcon = "_px-3";
export var suffix = "_px-9";
export var suffixContent = "_px-a";
export var suffixText = "_px-b";
export var wrapper = "_px-0";